/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2025 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import { useBreakpointValue } from '@chakra-ui/react'

export const useSelectStyles = () => {
  const components = {
    DownChevron: () => {},
    DropdownIndicator: () => {},
    IndicatorsContainer: () => {}
  }

  const defaultStyles = {
    container: (provided) => ({
      ...provided,
      padding: '0',
      margin: '0'
    }),
    input: (provided) => ({
      ...provided,
      padding: '0',
      margin: '0',
      fontSize: '14px'
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: '0px'
    })
  }

  const customStyles = useBreakpointValue({
    base: {
      ...defaultStyles,
      control: (provided) => ({
        ...provided,
        border: '1px solid #E2E8F0',
        borderRadius: '0.375rem',
        fontSize: '14px',
        minHeight: '39px',
        padding: '0 16px !important',
        width: '100% !important'
      })
    },
    md: {
      ...defaultStyles,
      control: (provided) => ({
        ...provided,
        border: 'none',
        borderRadius: '0px',
        fontSize: '14px',
        minHeight: '36px',
        '&:hover': {
          border: 'none'
        },
        padding: '0px',
        width: '250px'
      })
    }
  })

  return {
    components,
    customStyles
  }
}
